export const WIDTH_OWNERS = 140;
export const WIDTH_TENANTS = 240;
export const WIDTH_CONTRACT_DATE = 100;
